import { ConfigurationFieldType } from '@ydistri/api-sdk';

export interface ConditionalConfigurationContentPredicateData {
  fieldType: ConfigurationFieldType;
  value: string | undefined;
}

export type ConditionalConfigurationContentPredicate = (
  data: ConditionalConfigurationContentPredicateData[],
) => boolean;

export enum ConditionalConfigurationCheckboxesValue {
  ALL_ON,
  ALL_OFF,
  AT_LEAST_ONE_ON,
  AT_LEAST_ONE_OFF,
}
